import type { TFunction } from 'i18next';

import type { TTournamentBadge } from '@/api/cms';
import { getLocaleFlagIcon } from '@/helpers/cdn';
import { Country } from '@/helpers/conf';
import { Locale } from '@/helpers/languages';

interface IIcon {
  width: number;
  height: number;
  src: string;
}

interface IBadgeConfig {
  label: string;
  icon?: IIcon;
  iconStart?: IIcon;
  decorCoins?: boolean;
  decorStars?: boolean;
}

export const getBadgeConfig = (
  badge: TTournamentBadge,
  t: TFunction
): IBadgeConfig => {
  switch (badge) {
    case 'more_chances':
      return { label: t('badge.moreChances'), decorCoins: true };

    case 'de_only':
      return {
        label: t('badge.countryOnly', { country: Country.Germany }),
        icon: {
          width: 15,
          height: 10,
          src: getLocaleFlagIcon(Locale.GERMAN),
        },
      };

    case 'ca_only':
      return {
        label: t('badge.countryOnly', { country: Country.Canada }),
        icon: {
          width: 15,
          height: 10,
          src: getLocaleFlagIcon(Locale.ENGLISH_CANADA),
        },
      };

    case 'au_only':
      return {
        label: t('badge.countryOnly', { country: Country.Australia }),
        icon: {
          width: 15,
          height: 10,
          src: getLocaleFlagIcon(Locale.ENGLISH_AUSTRALIA),
        },
      };

    case 'nz_only':
      return {
        label: t('badge.countryOnly', { country: Country.NewZealand }),
        icon: {
          width: 15,
          height: 10,
          src: getLocaleFlagIcon(Locale.ENGLISH_NEW_ZEALAND),
        },
      };
    case 'ch_only':
      return {
        label: t('badge.countryOnly', { country: Country.Switzerland }),
        icon: {
          width: 15,
          height: 10,
          src: getLocaleFlagIcon(Locale.FRENCH_SWITZERLAND),
        },
      };
    case 'ie_only':
      return {
        label: t('badge.countryOnly', { country: Country.Ireland }),
        icon: {
          width: 15,
          height: 10,
          src: getLocaleFlagIcon(Locale.ENGLISH_IRELAND),
        },
      };
    case 'no_only':
      return {
        label: t('badge.countryOnly', { country: Country.Norway }),
        icon: {
          width: 15,
          height: 10,
          src: getLocaleFlagIcon(Locale.NORWEGIAN),
        },
      };

    case 'vip_only':
      return { label: t('badge.vip'), decorStars: true };

    case 'rush_24h':
      return {
        label: t('badge.rush', { hours: 24 }),
        icon: {
          width: 14,
          height: 14,
          src: '/tournaments/tournament-card/rocket-badge-icon.webp',
        },
      };

    case 'rush_12h':
      return {
        label: t('badge.rush', { hours: 12 }),
        icon: {
          width: 14,
          height: 14,
          src: '/tournaments/tournament-card/rocket-badge-icon.webp',
        },
      };

    case 'telegram':
      return {
        label: t('badge.telegram'),
        icon: {
          width: 17,
          height: 25,
          src: '/tournaments/tournament-card/telegram-badge-icon.webp',
        },
      };

    case 'branded_game':
      return {
        label: t('badge.branded_game'),
        icon: {
          width: 14,
          height: 14,
          src: '/tournaments/tournament-card/branded-game-badge.webp',
        },
      };

    case 'new_mechanics':
      return {
        label: t('badge.new_mechanics'),
        iconStart: {
          width: 18,
          height: 20,
          src: '/tournaments/tournament-card/new-mechanics-badge.webp',
        },
      };

    default:
      return { label: t('badge.lowCompetition'), decorCoins: true };
  }
};
